import { ENV, menusConfig, ossFileUrl } from '@/common/config';
import { isLogin, userInfo } from '@/models/userInfo';
import { getCookie } from '@/utils';
import request from '@/utils/request';
const userInfoFileName = '_material_home.txt';
/**
 * @description 设置配置文件信息
 */
export const setUserSettingInfo = async<T>(content: T) => {
  if (!isLogin) return
  const settingInfo = await getUserSettingInfo()
  let res = await request.post(`${menusConfig}/api/sdapi/userconfigure/saveFile`, {
    authCode: getCookie('authCode'),
    fileName: userInfo?.userId + userInfoFileName,
    content: JSON.stringify({
      ...settingInfo,
      ...content
    }),
  }, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
  return res; // 返回响应结果，视需要而定
};
// TODO: 要删除
(window as any).setNewGuideHide = setUserSettingInfo.bind(null, { newGuideHide: false })
/**
* @description 获取配置文件信息
*/
export const getUserSettingInfo = async () => {
  if (!isLogin) return
  const isExist = await isUserSettingInfoExist();
  if (isExist) {
    try {
      // 时间戳
      const time = new Date().getTime().toString();
      const url = `${ossFileUrl}/${userInfo?.userId + userInfoFileName}?v=${time}`;
      const response = await fetch(url);
      // 检查响应是否成功
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.text(); // 如果内容是文本格式
      const res = JSON.parse(data || '{}')
      return res
    } catch (error) {
      console.info('Error fetching content:', error);
    }
  }
  return null
};
/**
* @description 配置文件是否存在
*/
export const isUserSettingInfoExist = async () => {
  if (!isLogin) return
  let res = await request.post(`${menusConfig}/api/sdapi/userconfigure/existFile`, {
    authCode: getCookie('authCode'),
    configureFilePath: `configure/${(ENV === 'prod' || ENV === 'hws') ? 'pro' : ENV}/${userInfo?.userId + userInfoFileName}`,
  }, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
  return res?.result;
}; 
